const data = {
  hero: {
    title: "Sutramay Industries",
    tagline: "A dependable manufacturing partner for womenswear and menswear.",
    description:
      "Founded in 2026, Sutramay originated as a garment manufacturing unit specializing in womenswear and menswear. Our experience has given us a strong understanding of fabrics, production, quality and the changing needs of the market.",
  },

  about: {
    heading: "More About Sutramay",
    paragraphs: [
      "Founded in 2026, Sutramay originated as a garment manufacturing unit specializing in womenswear and menswear. Our experience has given us a strong understanding of fabrics, production, quality and the changing needs of the market.",
      "We believe good manufacturing comes down to getting the details right. From sourcing and sampling to production and finishing, we focus on consistency, quality and timely execution.",
      "We work closely with our clients to ensure every order is made to the right specifications and meets the quality expected from it.",
    ],
  },

  mission:
    "With detailed understanding of consistent changes in the market, we intend to establish ourselves as a dependable manufacturing partner for womenswear and menswear brands, delivering consistent quality, efficient production and reliable execution every time.",
  vision:
    "To build a strong, women led manufacturing business that grows steadily, creates opportunities, and earns a reputation for quality, reliability and integrity.",
  values: [
    { title: "Quality", description: "Quality and attention to every detail." },
    { title: "Consistency", description: "Consistency." },
    { title: "Reliability", description: "Reliability." },
    { title: "Continuous Improvement", description: "Continuous improvement as per market requirement." },
  ],
  valuesSummary:
    "Quality and attention to every detail, consistency, reliability, continuous improvement as per market requirement.",

  services: [
    {
      name: "Garment Manufacturing",
      description: "End to end manufacturing of womenswear and menswear, from sampling to final finishing.",
    },
    {
      name: "Design Development & Tech Packs",
      description: "Turning garment concepts into clear, production ready specifications.",
    },
    {
      name: "Stitching & Garment Assembly",
      description: "Precision stitching and efficient garment assembly to ensure high quality, durable, and well finished apparel.",
    },
  ],

  stats: [
    { name: "Products", value: "150" },
    { name: "Contracts", value: "75" },
    { name: "Happy Clients", value: "100" },
  ],
};

export default data;
